<template>
  <div class="d-flex h-100 flex-column">
    <GmbSearchField @search-updated="onEntitySearchUpdated"/>

    <div class="d-flex mt-1 flex-grow-1 h-0 flex-column">
      <FdScroll y>
        <GmbObsboxItem
            v-for="(entity, i) in filteredEntities"
            :class="{ 'mt-2': i != 0 }"
            :client="entity.client"
            :item-id="entity.identifier"
            :key="i"
            :organization="entity.organization"
            :project="entity.project"
        />
      </FdScroll>
    </div>
  </div>
</template>

<script>
import FdScroll from "@/flexdesign/Scroll";

import GmbObsboxItem from "@/widgets/ObsboxItem";
import GmbSearchField from "@/widgets/SearchField";

export default {
  name: "GmbObservatoryObsbox",

  components: {
    FdScroll,

    GmbObsboxItem,
    GmbSearchField,
  },

  props: {
    entities: Array,
  },

  data() {
    return {
      entityFilterString: "",
    };
  },

  computed: {
    filteredEntities() {
      if (!this.entities) return undefined;

      let filterString = this.entityFilterString.toLowerCase();
      if (!filterString) return this.entities;

      return this.entities.filter((entity) => {
        let fullText = (
            entity.client +
            " " +
            entity.project +
            " " +
            entity.organization
        ).toLowerCase();
        return fullText.includes(filterString);
      });
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    onEntitySearchUpdated(value) {
      this.entityFilterString = value;
    },
  },
};
</script>

<style lang="scss"></style>
